import { useState, useEffect } from "react";
import { usePrograms } from "./hooks"
import BaseSelectInput from "../BaseSelectInput";
import { T } from "react-translator-component";

export default function ProgramsSelectInput({value, bold = true, handleChange, required = false}) {
    
    const [program, setProgram] = useState(T("Programs"));
    const { programs, isLoading, isError } = usePrograms();

    const handleSelectedProgram = event => {
        setProgram(event.target.value);
        handleChange(event);
    }

    useEffect(()=>{
        setProgram(value)
    },[value]);

    return (
        <BaseSelectInput
            options={programs}
            bold={bold}
            handleChange={handleSelectedProgram}
            name={"programID"}
            id={"program"}
            placeholder={T("Programs")}
            selectedValue={program}
            required={required}
        />
    )
}